module.exports = __webpack_public_path__ + "static/media/company-introduction-2.d79e6bdf.jpg";